import { jsx as a } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import s from "classnames";
/* empty css               */
import { Fragment as m } from "../../../../external/preact/dist/preact.module.js";
const k = ({ columnsNumber: n, loading: r, emptyMessageDisplay: t }) => {
  const l = Array.from({ length: 10 }, (d, e) => e), o = Array.from({ length: n }, (d, e) => e);
  return /* @__PURE__ */ a(m, { children: [
    l.map((d, e) => /* @__PURE__ */ a("div", { className: "adyen-pe-data-grid__row", children: o.map((_, c) => /* @__PURE__ */ a("div", { className: "adyen-pe-data-grid__cell adyen-pe-data-grid__skeleton-cell", children: /* @__PURE__ */ a(
      "span",
      {
        className: s({
          "adyen-pe-data-grid__skeleton-cell-content adyen-pe-data-grid__skeleton-cell-content--loading": r,
          "adyen-pe-data-grid__empty-cell": !r
        })
      }
    ) }, `adyen-pe-data-grid-skeleton-cell-${c}`)) }, `adyen-pe-data-grid-skeleton-row-${e}`)),
    !r && t && t
  ] });
};
export {
  k as default
};
